import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const ImprintBlock = ({
	headline,
	text,
}) => (
	<>
		<Row>
			<Col>
				<h3>
					<b>{headline}</b>
				</h3>
			</Col>
		</Row>
		<Row className={'multiline-text mb-4'}>
			<Col>
				{text}
			</Col>
		</Row>
	</>
);

export default ImprintBlock;
